import { IncidentTableStyles, incidentFilterSelectedColour } from "../types";

export const incidentTableStyles: IncidentTableStyles = {
  filterTextFieldSx: {
    minWidth: 170,
    "& .MuiInputBase-root": {
      height: 38,
      borderRadius: "10px",
      fontSize: 13,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: incidentFilterSelectedColour,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: incidentFilterSelectedColour,
    },
    "& .MuiSelect-select": {
      fontSize: 13,
    },
  },
  boundaryTextFieldSx: {
    minWidth: 150,
    "& .MuiInputBase-root": {
      height: 38,
      borderRadius: "10px",
      fontSize: 13,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: incidentFilterSelectedColour,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: incidentFilterSelectedColour,
    },
    "& .MuiSelect-select": {
      fontSize: 13,
    },
  },
  areaTextFieldSx: {
    minWidth: 170,
    width: 200,
    "& .MuiInputBase-root": {
      height: 38,
      borderRadius: "10px",
      fontSize: 13,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: incidentFilterSelectedColour,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: incidentFilterSelectedColour,
    },
    "& .MuiSelect-select": {
      fontSize: 13,
    },
  },
  filterMenuItemSx: {
    "&.Mui-selected": {
      backgroundColor: `${incidentFilterSelectedColour}33`,
    },
    "&.Mui-selected:hover": {
      backgroundColor: `${incidentFilterSelectedColour}55`,
    },
  },
  datePickerTextFieldSx: {
    width: 132,
    "& .MuiInputBase-root": {
      height: 38,
      borderRadius: "10px",
      fontSize: 13,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: incidentFilterSelectedColour,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: incidentFilterSelectedColour,
    },
  },
  datePickerDaySx: {
    "&.Mui-selected": {
      backgroundColor: incidentFilterSelectedColour,
      color: "#000",
    },
    "&.Mui-selected:hover": {
      backgroundColor: incidentFilterSelectedColour,
    },
  },
  filterToolbarSx: {
    position: "relative",
    marginBottom: 2,
    padding: 1.5,
    borderRadius: "14px",
    backgroundColor: "rgba(0, 0, 0, 0.02)",
  },
  filterToolbarContentSx: {
    display: "flex",
    gap: 1.25,
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-around",
    width: "100%",
    paddingRight: 4,
  },
  resetFiltersButtonSx: {
    position: "absolute",
    top: 8,
    right: 8,
  },
  dateFieldSwitchContainerSx: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    flexDirection: "column",
  },
  datePickerContainerSx: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
  },
  areaOperatorSelectSx: {
    maxWidth: 112,
    fontSize: 15,
    "& .MuiSelect-select": {
      paddingRight: "24px",
    },
  },
};
